<template>
    <div class="checkout">
        <Breadcrumbs main="Ecommerce" title="Checkout" />

        <Card9 colClass="container-fluid" cardhaderClass="title-header" title="Billing Details">
            <div class="row">
                <checkoutForm />
                <checkoutDetail />
            </div>
        </Card9>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const Card9 = defineAsyncComponent(() => import("@/components/commen/card/cardData9.vue"))
const checkoutForm = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/checkoutForm.vue"))
const checkoutDetail = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/checkoutDetail.vue"))
</script>